import useFetchApi from "@/api/hooks/useFetchApi";
import SiteLogo from "@/components/SiteLogo";
import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {

    const {
        data,
        isLoading,
        error
    } = useFetchApi({
        url: "/v1/gp/",
        service: "CMS_PROC"
    })



    //son blog yazıları
    // interface Post {
    //     _id: string;
    //     __meta__created_at: string;
    //     title: string;
    // }

    // const { data: rawData } = useFetchApi({
    //     url: "/v1/gp/677fae22d2c0311ca14f6d08/tr/find?list_related=false&list_referenced=false&limit=3&skip=0&sort=__meta__created_at%3Adesc",
    //     service: "CMS_PROC",
    // });

    // const lastPostsData: Post[] = Array.isArray(rawData?.results) ? rawData.results : [];



    return (
        <>
            <footer className="page_contact ls parallax section_padding_top_50 section_padding_bottom_30 columns_padding_25" data-stellar-background-ratio="0.5">
                <div className="container">
                    <div className="row item-content">
                        <div className="col-md-4 col-sm-6 ">

                            <div className="widget widget_pages">
                                <h3 className="widget-title">Site Haritası</h3>
                                <hr className="divider_2_30 left-important main_bg_color" />
                                <ul className="greylinks">
                                    <li>
                                        <Link to="/hakkimizda">Hakkımızda</Link>
                                    </li>
                                    <li>
                                        <Link to="/urunler">Ürünler</Link>
                                    </li>
                                    <li>
                                        <Link to="/katalog">Bilgi Havuzu</Link>
                                    </li>
                                    <li>
                                        <Link to="/galeri-liste/Resim">Galeri</Link>
                                    </li>
                                    <li>
                                        <Link to="/haberler-duyurular/haberler">Haberler</Link>
                                    </li>
                                    <li>
                                        <Link to="/iletisim">İletişim</Link>
                                    </li>
                                </ul>
                            </div>



                            {/* <div className="widget_text">
                                <h3 className="widget-title">Kariyer</h3>
                                <p>Kurulduğu günden bu yana güvenli ve kaliteli ürünler sunmayı hedefleyen firmamız; endüstriyel gazlarda HABAŞ A.Ş., yangın söndürücülerde BKS A.Ş. , BURSAN A.Ş. ve BELLA bayilikleri ile müşterilerimize hizmet vermektedir.
                                </p>
                            </div> */}
                        </div>

                        {/* <div className="col-md-3 col-sm-6 ">
                            <div className="widget widget_recent_entries">
                                <h3 className="widget-title">Son Blog Yazıları</h3>
                                <ul>
                                    {isLoading ? (
                                        <li>Yükleniyor...</li>
                                    ) : error ? (
                                        <li>Bir hata oluştu: {error.message}</li>
                                    ) : lastPostsData.length > 0 ? (
                                        lastPostsData.map((post: Post) => (
                                            <li key={post._id}>
                                                <Link to={`/blog/${post._id}`}>
                                                    <p className="post-date">
                                                        <Link to={`/blog/${post._id}`}>
                                                            {post.__meta__created_at
                                                                ? new Date(post.__meta__created_at).toLocaleDateString("tr-TR")
                                                                : "Tarih Bilinmiyor"}
                                                        </Link>
                                                    </p>
                                                    <p>{post.title}</p>
                                                </Link>
                                            </li>
                                        ))
                                    ) : (
                                        <li>Gösterilecek blog bulunamadı.</li>
                                    )}
                                </ul>
                            </div>
                        </div> */}

                        {/* <div className="col-md-3 col-sm-6 ">
                            <p>---</p>
                        </div> */}

                        <div className="col-md-4 col-sm-6 ">
                            <div className="widget_text">
                                <h3 className="widget-title">İletişim</h3>
                                <hr className="divider_2_30 left-important main_bg_color" />

                                <p>Adres: 2797 Sok. No:6 (Çınarlı Diş Hastahanesi Arkası) Çınarlı -Konak- İZMİR</p>
                                <div className="border-paragraphs">
                                    <p>
                                        <i className="rt-icon2-device-phone highlight" />Tel: +90 232 435 70 69
                                    </p>
                                    <p>
                                        {/* https://wa.me/15551234567 */}
                                        <i className="rt-icon2-device-phone highlight" />Tel: +90 232 462 26 41
                                    </p>
                                    <p>
                                        <a href="https://wa.me/905375951415" target="_blank" rel="noopener noreferrer">
                                            <i className="rt-icon2-whatsapp highlight" /> WhatsApp: +90 537 595 14 15
                                        </a>
                                    </p>
                                    <p>
                                        <i className="rt-icon2-mail2 highlight" />
                                        <a href="mailto:info@gunes-gaz.com">info@gunes-gaz.com</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6 ">
                            <div className="widget_text">
                                <h3 className="widget-title">Sosyal Medya</h3>
                                <hr className="divider_2_30 left-important main_bg_color" />

                                <div className="media">
                                    <div className="media-left media-middle">
                                        <Link to="https://www.instagram.com/" className="social-icon color-icon bg-icon soc-instagram" />
                                    </div>
                                    <div className="media-body media-middle">
                                        İnstagram
                                    </div>
                                </div>


                                <div className="media">
                                    <div className="media-left media-middle">
                                        <Link to="https://www.facebook.com/gunesgaz/" className="social-icon color-icon bg-icon soc-facebook" />
                                    </div>
                                    <div className="media-body media-middle">
                                        Facebook
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <section className="page_copyright cs main_color2 table_section section_padding_top_30 section_padding_bottom_30">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6 text-center">
                            <p className="bold fontsize_12 text-uppercase kanit" style={{color:"#dbdbdb"}}>© Copyright 2025 Güneş Gaz
                                <span className="black"> | Web Tasarım : Egebilgi</span>

                            </p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Footer;